
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { PERMISSION } from '@/permissions';
import Toast from '@/utils/toast';
import SuitesHeader from '@/components/shared/suites/SuitesHeader.vue';
import InfoBanner from '@/components/shared/suites/InfoBanner.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';
import MenuGroupList from '@/components/menu-groups/MenuGroupList.vue';
import MenuGroupModal from '@/components/menu-groups/MenuGroupModal.vue';
import FullPageSpinner from '@/components/shared/suites/FullPageSpinner.vue';

const namespace: string = 'menus';

@Component<MenuGroups>({
	components: {
		SuitesHeader,
		InfoBanner,
		TextButton,
		MenuGroupList,
		MenuGroupModal,
		FullPageSpinner
	}
})
export default class MenuGroups extends Vue {
	@Action('fetchMenuGroups', { namespace }) private fetchMenuGroups!: () => Promise<void>;
	@Action('updateRestaurant', { namespace: 'auth' }) private updateRestaurant!: (restaurant: Restaurant | object) => Promise<void>;
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;
	@Getter('getMenuGroups', { namespace }) private menuGroups!: MenuGroup[];

	private PERMISSION = PERMISSION;
	private isDataFetching: boolean = false;
	private isRestaurantUpdating: boolean = false;
	private displayModal: boolean = false;
	private mutableRestaurant: Restaurant = {} as Restaurant;
	private selectedMenuGroup: MenuGroup | undefined = {} as MenuGroup;

	private get breadcrumbsArray(): Breadcrumb[] {
		return [
			{
				text: this.$t('settings.header'),
				to: '/advanced',
				exact: true
			},
			{
				text: this.$t('settings.menu_groups.header'),
				to: '/advanced/menu-groups',
				exact: true
			}
		];
	}

	/**
	 * Fetch the menu groups if they haven't been fetched before.
	 *
	 * @return {Promise<void>}
	 */
	private async created(): Promise<void> {
		this.mutableRestaurant = this.restaurant;
		if(!this.mutableRestaurant.marketplace_hub) {
			this.$router.push('/menus').catch(() => {});
		}

		this.isDataFetching = true;
		try {
			await this.fetchMenuGroups();
		}
		catch (errorMessage) {
			Toast.error(this.$t('settings.menu_groups.error_fetching', { errorMessage }));
		}
		finally {
			this.isDataFetching = false;
		}
	}

	/**
	 * Update the restaurant multiple mids flag.
	 *
	 * @return {Promise<void>}
	 */
	private async setRestaurantMultipleMidsFlag(): Promise<void> {
		try {
			this.isRestaurantUpdating = true;
			await this.updateRestaurant({ restaurant: { id: this.mutableRestaurant.id, multiple_mids: this.mutableRestaurant.multiple_mids } });
		}
		catch (errorMessage) {
			Toast.error(this.$t('settings.menu_groups.error_updating_location', { errorMessage }));
		}
		finally {
			this.isRestaurantUpdating = false;
		}
	}

	private showModal(menuGroup?: MenuGroup): void {
		this.selectedMenuGroup = menuGroup;
		this.displayModal = true;
	}
}
